import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'baseAnonymizeFullName' })
export class BaseAnonymizeFullNamePipe implements PipeTransform {
  transform(firstName: string | undefined, lastName: string | undefined): string {
    if (!firstName && !lastName) {
      return '';
    }

    if (!firstName && lastName) {
      return lastName[0];
    }

    if (!lastName && firstName) {
      return firstName[0];
    }

    return `${firstName![0]}. ${lastName![0]}.`;
  }
}
